module.exports = __webpack_public_path__ + "img/3diamond-05.a8df3983.svg";